import { z } from 'zod';

/** GET /inicio/resumo: painel Inicio por papel. Cada bloco vem `null` quando o usuario nao tem a permissao da tela de origem. */
export const INICIO_PERIODOS = ['mes', '30', '90'] as const;
export const inicioResumoQuerySchema = z.object({ periodo: z.enum(INICIO_PERIODOS).default('mes') });
export type InicioResumoQuery = z.infer<typeof inicioResumoQuerySchema>;

export interface InicioFunilEtapa {
  status: 'RASCUNHO' | 'ENVIADO' | 'EM_NEGOCIACAO' | 'APROVADO';
  /** Orcamentos que chegaram a esta etapa ou alem (RASCUNHO = todos menos perdidos). */
  quantidade: number;
  /** Soma do total (R$, string decimal). */
  total: string;
  /** Fracao da etapa anterior que chegou a esta (4 casas); null na primeira etapa ou sem base. */
  conversao: string | null;
}

export interface InicioPedeAcao {
  id: 'LOTES_PENDENTES' | 'REVISAR_PRECO' | 'ORCAMENTOS_VENCENDO' | 'ITENS_SEM_CUSTO' | 'RATEIO_ABERTO';
  titulo: string;
  quantidade: number;
  /** Rota da tela e a busca (query string) ja filtrada. */
  rota: string;
  busca: Record<string, string>;
}

export interface InicioResumoResponse {
  periodo: (typeof INICIO_PERIODOS)[number];
  /** AAAA-MM-DD, inclusivos. */
  de: string;
  ate: string;
  funil: null | {
    escopo: 'proprios' | 'todos';
    etapas: InicioFunilEtapa[];
    perdidos: { quantidade: number; total: string };
    vencidos: { quantidade: number; total: string };
  };
  pedeAcao: InicioPedeAcao[];
  indicadores: {
    /** Lucro medio dos aprovados (fracao) e a meta (lucro desejado padrao); sem R$. */
    lucroMedioAprovado: string | null;
    metaLucro: string | null;
    ticketMedio: string | null;
    orcamentosPorVendedor: Array<{ nome: string; quantidade: number; total: string }> | null;
    itensPorTipo: Record<string, number> | null;
    fichasTecnicas: number | null;
    clientes: number | null;
  };
  ultimoRateio: null | { competencia: string; status: string; cpmMedio: string | null };
  pcp: null | { fichasSemVersaoEscolhida: number; centrosSemCpm: number; itensSemCusto: number };
}
